// extracted by mini-css-extract-plugin
export default {"form":"UpdateReverence_form__8xMu1"};